module.exports = __webpack_public_path__ + "media/img/question-d8ff8eb0.png";